export default __webpack_public_path__ + "static/media/facebook.2061182c.svg";